import React from "react";

import IMapSidebarContext from "../types/IMapSidebarContext";

const MapSidebarContext = React.createContext<IMapSidebarContext>({
  setSidebarWidth: () => {},
});

export default MapSidebarContext;
